import type { MaybeRef, VueInstance } from '@vueuse/core';
import { inject, type FunctionalComponent, type InjectionKey } from 'vue';

export type Pane = {
  id: string;
  label: string;
  title: string;
  icon: VueInstance | FunctionalComponent;
};

export const toolbarKey = Symbol('jk/toolbar') as InjectionKey<
  {
    open: boolean,
    select: (pane: Pane) => Promise<void> | void;
    selected: MaybeRef<string | undefined>;
    close: () => void;
  }
>;

export const useToolbar = () => inject(toolbarKey);
